import { graphqlFetch } from '@api/graphql/gql-fetch';
import {
	type PostCreateStorefrontReviewResponse,
	type PostCreateStorefrontReviewVariables,
	postAuthedStorefrontReviewQuery,
} from '@api/graphql/reviews/postAuthedStorefrontReview';
import { getUnifiedReviewsUrl } from '@api/reviews/url';
import { Logger } from '@utils/logger/logger';

export const postAuthedStorefrontReview = async (
	token: string,
	variables: PostCreateStorefrontReviewVariables,
) => {
	const headers = new Headers();
	headers.append('membership-session-token', token);
	headers.append('x-tenant-id', 'tk-us');
	try {
		const result = await graphqlFetch<PostCreateStorefrontReviewResponse>({
			url: getUnifiedReviewsUrl(),
			query: postAuthedStorefrontReviewQuery,
			variables,
			headers,
		});

		if (result.errors?.length) {
			const errors = result.errors.map((error) => new Error(error.message));
			for (const error of errors) {
				Logger.error({
					log_message: 'GraphQL Error creating storefront review',
					errorToLog: error,
					newRelic: true,
				});
			}
			throw errors;
		}

		return {
			data: {
				id: result.data.createReview.review.id,
			},
		};
	} catch (e) {
		if (!Array.isArray(e)) {
			Logger.error({
				errorToLog: e,
				newRelic: true,
				log_message: 'Error creating storefront review',
			});
		}
		throw e;
	}
};
